/** Shared UI for landlord Team + System pages (Messages, Settings, Support, Staff). */
import { UK } from './pipelineFormShared';

export const SYSTEM_PAGE_CSS = `
  .sys-page { padding: 24px; max-width: 1400px; margin: 0 auto; font-family: 'DM Sans', system-ui, sans-serif; background: #eef2f6; min-height: 100vh; }
  .sys-page * { box-sizing: border-box; }

  .sys-banner-wrap { margin: -24px -24px 28px; padding: 10px 10px 14px; border-radius: 0 0 22px 22px; box-shadow: 0 12px 40px rgba(1,33,105,0.28); position: relative; overflow: hidden; }
  .sys-banner-sales { background: linear-gradient(145deg, #1e3a5f 0%, #2563eb 40%, #0369a1 72%, #0d9488 100%); }
  .sys-banner-staff {
    background: linear-gradient(135deg, #16a34a 0%, #dc2626 18%, #eab308 36%, #2563eb 54%, #ec4899 72%, #f97316 100%);
  }
  /* Settings — professional UK blue / white / red (not a busy Union Jack pattern) */
  .sys-banner-uk {
    background: linear-gradient(155deg, ${UK.blue} 0%, #1e3a8a 42%, #012169 78%, #0f172a 100%);
  }
  .sys-banner-uk::before {
    content: '';
    position: absolute;
    inset: 0;
    pointer-events: none;
    background:
      radial-gradient(ellipse 80% 60% at 100% 0%, rgba(255,255,255,0.12) 0%, transparent 55%),
      radial-gradient(ellipse 50% 40% at 0% 100%, rgba(200,16,46,0.22) 0%, transparent 50%);
  }
  .sys-banner-uk::after {
    content: '';
    position: absolute;
    top: 0; left: 0; right: 0;
    height: 5px;
    background: linear-gradient(to right,
      ${UK.blue} 0%, ${UK.blue} calc(50% - 28px),
      ${UK.white} calc(50% - 28px), ${UK.white} calc(50% - 8px),
      ${UK.red} calc(50% - 8px), ${UK.red} calc(50% + 8px),
      ${UK.white} calc(50% + 8px), ${UK.white} calc(50% + 28px),
      ${UK.blue} calc(50% + 28px), ${UK.blue} 100%
    );
    box-shadow: 0 1px 0 rgba(255,255,255,0.35);
  }
  .sys-banner-uk .sys-banner-glass {
    position: relative;
    z-index: 1;
    background: rgba(255,255,255,0.14);
    border: 1px solid rgba(255,255,255,0.32);
  }
  .sys-banner-uk .sys-banner-glass h1 {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .sys-banner-uk .sys-banner-glass h1::before {
    content: '';
    width: 4px;
    height: 28px;
    border-radius: 2px;
    background: linear-gradient(to bottom, ${UK.red}, ${UK.white} 45%, ${UK.blue});
    flex-shrink: 0;
    box-shadow: 0 0 12px rgba(200,16,46,0.45);
  }

  .sys-banner-glass {
    display: flex; align-items: center; justify-content: space-between; gap: 20px; flex-wrap: wrap;
    background: rgba(255,255,255,0.12); backdrop-filter: blur(22px);
    border: 1px solid rgba(255,255,255,0.28); border-radius: 18px;
    padding: 30px 34px; box-shadow: 0 8px 32px rgba(0,0,0,0.12), inset 0 1px 0 rgba(255,255,255,0.35);
  }
  .sys-banner-glass h1 { margin: 0; font-size: 32px; font-weight: 800; color: #fff; letter-spacing: -0.03em; text-shadow: 0 2px 10px rgba(0,0,0,0.2); }
  .sys-banner-glass p { margin: 8px 0 0; font-size: 14px; color: rgba(255,255,255,0.9); }
  .sys-banner-actions { display: flex; gap: 8px; flex-wrap: wrap; align-items: center; }
  .sys-btn-white { background: #fff; color: ${UK.blue}; border: none; border-radius: 10px; padding: 11px 22px; font-weight: 800; font-size: 14px; cursor: pointer; box-shadow: 0 4px 16px rgba(0,0,0,0.14); font-family: inherit; }
  .sys-btn-save { background: ${UK.red}; color: #fff; border: none; border-radius: 10px; padding: 11px 24px; font-weight: 800; font-size: 14px; cursor: pointer; box-shadow: 0 4px 16px rgba(200,16,46,0.35); font-family: inherit; }
  .sys-btn-save:disabled { background: #94a3b8; box-shadow: none; cursor: not-allowed; }
  .sys-btn-glass { background: rgba(255,255,255,0.14); color: #fff; border: 1px solid rgba(255,255,255,0.35); border-radius: 10px; padding: 10px 18px; font-weight: 700; font-size: 13px; cursor: pointer; font-family: inherit; }

  .sys-kpi-row { display: grid; grid-template-columns: repeat(auto-fit, minmax(140px, 1fr)); gap: 14px; margin-bottom: 22px; }
  .sys-kpi { border-radius: 16px; padding: 22px 20px 18px; min-height: 100px; }
  .sys-kpi-white { background: ${UK.white}; border: 1.5px solid #e2e8f0; box-shadow: 0 6px 20px rgba(0,0,0,0.06); }
  .sys-kpi-blue { background: linear-gradient(145deg, #2563eb, #3b82f6); box-shadow: 0 8px 24px rgba(37,99,235,0.28); }
  .sys-kpi-teal { background: linear-gradient(145deg, #0d9488, #14b8a6); box-shadow: 0 8px 24px rgba(13,148,136,0.28); }
  .sys-kpi .kl { font-size: 10px; font-weight: 800; text-transform: uppercase; letter-spacing: 0.09em; margin-bottom: 8px; }
  .sys-kpi-white .kl { color: #64748b; }
  .sys-kpi-blue .kl, .sys-kpi-teal .kl { color: rgba(255,255,255,0.85); }
  .sys-kpi .kv { font-size: 30px; font-weight: 800; line-height: 1.1; font-family: 'DM Mono', monospace; }
  .sys-kpi-white .kv { color: #2563eb; }
  .sys-kpi-blue .kv, .sys-kpi-teal .kv { color: #fff; }

  .sys-panel { background: #fff; border-radius: 14px; border: 1px solid #e2e8f0; padding: 20px 22px; margin-bottom: 20px; box-shadow: 0 4px 16px rgba(0,0,0,0.04); }
  .sys-panel h3 { margin: 0 0 14px; font-size: 15px; font-weight: 800; color: #1e293b; }
  .sys-toolbar { display: flex; gap: 12px; margin-bottom: 20px; flex-wrap: wrap; align-items: center; }
  .sys-search { flex: 1; min-width: 200px; max-width: 400px; padding: 10px 14px; background: #fff; border: 1.5px solid #e2e8f0; border-radius: 10px; font-size: 14px; }

  .sys-role-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(260px, 1fr)); gap: 12px; }
  .sys-role-card { border-radius: 12px; padding: 14px 16px; border: 1.5px solid #e2e8f0; background: #f8fafc; }
  .sys-role-card .role-name { font-weight: 800; font-size: 13px; margin-bottom: 6px; }
  .sys-role-card .role-desc { font-size: 12px; color: #64748b; line-height: 1.5; }

  .sys-invite-preview { background: #f8fafc; border: 1.5px dashed #cbd5e1; border-radius: 12px; padding: 18px 20px; font-size: 13px; color: #334155; line-height: 1.6; white-space: pre-wrap; }

  @media (max-width: 700px) {
    .sys-page { padding: 14px 12px 60px; }
    .sys-banner-wrap { margin: -14px -12px 20px; border-radius: 0 0 16px 16px; }
    .sys-banner-glass { padding: 20px 18px; }
    .sys-banner-glass h1 { font-size: 22px; }
  }
`;

export const LANDLORD_ROLE_PERMISSIONS = [
  { role: 'Admin', color: '#dc2626', access: 'Full access — settings, billing, staff, all portfolio & compliance modules.' },
  { role: 'Manager', color: '#9333ea', access: 'Invite & manage staff, properties, tenants, rent, maintenance, messages.' },
  { role: 'Editor', color: '#16a34a', access: 'Edit properties, tenants, leases, maintenance, viewings, inventory & messages.' },
  { role: 'Viewer', color: '#64748b', access: 'Read-only — portfolio, rent tracker, certificates, reports & audit log.' },
  { role: 'Staff', color: '#2563eb', access: 'Day-to-day ops — maintenance jobs, viewings, inventory check-ins, tenant comms.' },
];

export function staffInvitePreview(
  businessName: string,
  staffName = 'New team member',
  adminName = 'Your manager',
  businessEmail?: string,
): string {
  const help = businessEmail?.trim()
    ? `admin@shahosuite.com or ${businessEmail.trim()}`
    : 'admin@shahosuite.com';
  return `Subject: You've been invited to join ${businessName} on LandLord Suite

Hi ${staffName},

${adminName} has invited you to join ${businessName} on LandLord Suite (the landlord property management platform.)

Please complete your staff invite form to verify your email and set your password (required before you can access ${businessName}'s account):
→ {Invite link — expires in 24 hours}

Once you've completed the invite form, you'll be able to:
- Manage properties, tenants & leases
- Handle maintenance requests & viewings
- Track rent & compliance certificates
- Send messages to tenants
- Update your profile & photo

Need help? ${help}

Welcome to the team at ${businessName}!
— The ShahoSuite Team`;
}
